
import {reactive} from 'vue';

export {ContextMenuControllerSingleton as default };

/**
* Context Menu display controller
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContextMenuController {
  /**
   * Context Menu Event
   *
   * @public
   *
   * @type {Event}
   *
   * @since 7.0.0
   */
  event;

  /**
   * Target Element
   *
   * @public
   *
   * @type {Node}
   *
   * @since 7.0.0
   */
  target;

  /**
   * Stores last target
   *
   * @public
   *
   * @type {Node}
   *
   * @since 7.0.0
   */
  last_target;

   /**
   * Sets the context menu event
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Event} event
   *
   * @return {void}
   */
  setEvent(event) {
    this.event = event;
  }

   /**
   * Sets the context menu target
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Node} target
   *
   * @return {void}
   */
  setTarget(target) {
    this.last_target = this.target;
    this.target      = target;
  }
}

const ContextMenuControllerSingleton = reactive(new ContextMenuController());